import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Overview from "../pages/overview/page";
import EmptyPage from "../pages/empty/page";
import UserListPage from "../pages/users/list/page";
import NotificationManagement from "../pages/notifications/management/page";
import NotificationList from "../pages/notifications/list/page";
import NotificationRecords from "../pages/notifications/records/page";
import SystemLogsPage from "../pages/system/logs/page";
import SystemConfigPage from "../pages/system/config/page";
import SystemMaintenancePage from "../pages/system/maintenance/page";
import SystemTasksPage from "../pages/system/tasks/page";
import TenantListPage from "../pages/tenants/list/page";
import RolesPage from "../pages/permissions/roles/page";
import AccountsPage from "../pages/permissions/accounts/page";
import DepartmentsPage from "../pages/permissions/departments/page";
import ServersPage from "../pages/resources/servers/page";
import TemplatesPage from "../pages/resources/templates/page";
import DatacentersPage from "../pages/resources/datacenters/page";
import AppsPage from "../pages/resources/apps/page";
import AppCategoriesPage from "../pages/resources/apps/categories/page";
import ProductListPage from "../pages/products/list/page";
import ProductDisksPage from "../pages/products/disks/page";
import ProductRechargePage from "../pages/products/recharge/page";
import ProductCategoriesPage from "../pages/products/categories/page";
import OrderListPage from "../pages/orders/list/page";
import AfterSalesPage from "../pages/orders/after-sales/page";
import OrderConfigPage from "../pages/orders/config/page";
import PointsOperationsPage from "../pages/points/operations/page";
import PointsRechargePage from "../pages/points/recharge/page";
import CloudPCsPage from "../pages/user-resources/cloud-pcs/page";
import CloudDisksPage from "../pages/user-resources/cloud-disks/page";
import VenuesPage from "../pages/terminals/venues/page";
import ThinClientsPage from "../pages/terminals/thin-clients/page";
import RechargeRecordsPage from "../pages/billing/recharge-records/page";
import BillSummaryPage from "../pages/billing/summary/page";
import BillDetailsPage from "../pages/billing/details/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Overview />,
  },
  {
    path: "/overview",
    element: <Overview />,
  },
  {
    path: "/users/list",
    element: <UserListPage />,
  },
  {
    path: "/tenants/list",
    element: <TenantListPage />,
  },
  {
    path: "/resources/servers",
    element: <ServersPage />,
  },
  {
    path: "/resources/templates",
    element: <TemplatesPage />,
  },
  {
    path: "/resources/datacenters",
    element: <DatacentersPage />,
  },
  {
    path: "/resources/apps",
    element: <AppsPage />,
  },
  {
    path: "/resources/apps/categories",
    element: <AppCategoriesPage />,
  },
  {
    path: "/monitoring/faults",
    element: <EmptyPage />,
  },
  {
    path: "/products/list",
    element: <ProductListPage />,
  },
  {
    path: "/products/disks",
    element: <ProductDisksPage />,
  },
  {
    path: "/products/recharge",
    element: <ProductRechargePage />,
  },
  {
    path: "/products/categories",
    element: <ProductCategoriesPage />,
  },
  {
    path: "/orders/list",
    element: <OrderListPage />,
  },
  {
    path: "/orders/after-sales",
    element: <AfterSalesPage />,
  },
  {
    path: "/orders/config",
    element: <OrderConfigPage />,
  },
  {
    path: "/points/operations",
    element: <PointsOperationsPage />,
  },
  {
    path: "/points/recharge",
    element: <PointsRechargePage />,
  },
  {
    path: "/user-resources/cloud-pcs",
    element: <CloudPCsPage />,
  },
  {
    path: "/user-resources/cloud-disks",
    element: <CloudDisksPage />,
  },
  {
    path: "/terminals/venues",
    element: <VenuesPage />,
  },
  {
    path: "/terminals/thin-clients",
    element: <ThinClientsPage />,
  },
  {
    path: "/billing/recharge-records",
    element: <RechargeRecordsPage />,
  },
  {
    path: "/billing/summary",
    element: <BillSummaryPage />,
  },
  {
    path: "/billing/details",
    element: <BillDetailsPage />,
  },
  {
    path: "/permissions/roles",
    element: <RolesPage />,
  },
  {
    path: "/permissions/accounts",
    element: <AccountsPage />,
  },
  {
    path: "/permissions/departments",
    element: <DepartmentsPage />,
  },
  {
    path: "/notifications/list",
    element: <NotificationList />,
  },
  {
    path: "/notifications/management",
    element: <NotificationManagement />,
  },
  {
    path: "/notifications/records",
    element: <NotificationRecords />,
  },
  {
    path: "/system/logs",
    element: <SystemLogsPage />,
  },
  {
    path: "/system/config",
    element: <SystemConfigPage />,
  },
  {
    path: "/system/maintenance",
    element: <SystemMaintenancePage />,
  },
  {
    path: "/system/tasks",
    element: <SystemTasksPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
